import { topicCollections } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function TopicsSection() {
  return (
    <section id="topics" className="border-y border-background-200 bg-background-100/50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
              题材合集入口
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              按领域翻，找到你想追的那一类
            </h2>
            <p className="mt-4 text-[15px] leading-8 text-foreground-700">
              六个常看领域各自成册，点进去就是该题材下的完整爆料汇总，省去在信息流里反复筛选的时间。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topicCollections.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 80}>
              <a
                href="#featured"
                className="group flex h-full items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-800 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${topic.icon} text-2xl`} />
                </span>
                <span className="flex flex-1 flex-col">
                  <span className="flex items-center justify-between gap-3">
                    <span className="font-heading text-base font-bold text-foreground-950">
                      {topic.name}
                    </span>
                    <i className="ri-arrow-right-up-line text-lg text-foreground-300 transition-colors group-hover:text-primary-500" />
                  </span>
                  <span className="mt-2 text-sm leading-6 text-foreground-600">
                    {topic.description}
                  </span>
                  <span className="mt-3 text-xs font-medium text-foreground-500">
                    已收录 {topic.count}
                  </span>
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}